import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import PostForm from "../../Common/PostForm";
import { deleteChatPosts, getChatPosts, openDialog } from "../../../store/actions";
import ChatPostComponent from "./ChatPost";
import { ChatPost } from "../../../lib/types";
import SubMenu from "../../Menu/SubMenu";
import { CHAT_TYPE, POST_CONTEXT } from "../../../lib/enums";

interface IProps {
  type: number;
}

const mapStateToProps = (state: any) => ({
  alliance: state.governorate.alliance,
  chatPosts: state.governorate.chatPosts
})

const mapDispatchToState = (dispatch: any) => ({
  getPostsDispatch: (chatType: number) => dispatch(getChatPosts(chatType)),
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  deletePostsDispatch: (postIds: number[]) => dispatch(deleteChatPosts(postIds))
})

const connector = connect(mapStateToProps, mapDispatchToState)

const Chat = ({
  type,
  alliance,
  chatPosts,
  getPostsDispatch,
  openDialogDispatch,
  deletePostsDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const [postsToDelete, setPostsToDelete] = useState<number[]>([]);
  const upperDeleteRef = useRef<HTMLAnchorElement>(null);
  const lowerDeleteRef = useRef<HTMLAnchorElement>(null);
  const textAreaRef = React.createRef<HTMLTextAreaElement>();

  useEffect(() => {
    getPostsDispatch(type);
    setPostsToDelete([]);
  }, [type]);

  const toggleToDelete = (postId: number) => {
    const deleted = postsToDelete.slice();
    const postIndex = deleted.indexOf(postId);

    if (postIndex === -1) {
      deleted.push(postId);
    } else {
      deleted.splice(postIndex, 1);
    }

    setPostsToDelete(deleted);
  }

  const deletePosts = () => {
    deletePostsDispatch(postsToDelete);
    setPostsToDelete([]);
  }

  const addReactMessage = (message: string) => {
    if (textAreaRef.current) {
      textAreaRef.current.value = `${message}
${textAreaRef.current.value}`;
      textAreaRef.current.focus();
      textAreaRef.current
        .setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
    }
  }

  return (<>
    <SubMenu
      tabs={[
        {
          name: "Chat",
          title: "Alliance Chat",
          icon: "politika",
          label: "Alliance Chat",
          active: type === CHAT_TYPE.Alliance,
          disabled: !alliance,
          parameters: {
            type: CHAT_TYPE.Alliance,
            reload: type !== CHAT_TYPE.Alliance
          }
        },
        {
          name: "Chat",
          title: "World Chat",
          icon: "politika",
          label: "World Chat",
          active: type === CHAT_TYPE.Public,
          parameters: {
            type: CHAT_TYPE.Public,
            reload: type !== CHAT_TYPE.Public
          }
        },
        {
          name: "AllianceBoard",
          title: "Alliance board",
          icon: "statistiky",
          label: "Alliance board",
          active: false
        }
      ]}
    />

    <h2 className="h2 h2-first">
      <span className="bordered">New post</span>
    </h2>
    <span className="divider"/>

    <section className="boxes-group">
      <PostForm context={POST_CONTEXT.Chat} chatType={type} textAreaRef={textAreaRef}/>
      <span className="divider"/>
    </section>
    <section className="boxes-group">
      <header className="forum-header">
        <div className="left-actions">
          <a
            ref={upperDeleteRef}
            className="icon icon-smazat icon-xmd item icon-standalone"
            onClick={() => openDialogDispatch({
              name: "ConfirmDialog",
              clear: true,
              question: "Do you realy want to delete slected posts?",
              cancel: "Back",
              confirm: "Delete",
              confirmAction: deletePosts,
              elementRef: upperDeleteRef.current
            })}
          />
        </div>
      </header>
      <span className="divider"/>
      <div className="box">
        <div className="comments" id="comments">
          {chatPosts && chatPosts.length ? chatPosts.map((post: ChatPost) => <ChatPostComponent
            post={post}
            toDelete={postsToDelete.includes(post.id)}
            toggleToDelete={() => toggleToDelete(post.id)}
            addReactMessage={addReactMessage}
          />) : <p className={"text-info"}>No posts found in chat</p>}
        </div>
      </div>
      <span className="divider"/>
      <footer className="forum-footer load-block">
        <div className="left-actions">
          <a
            ref={lowerDeleteRef}
            className="icon icon-smazat icon-xmd item icon-standalone"
            onClick={() => openDialogDispatch({
              name: "ConfirmDialog",
              clear: true,
              question: "Do you realy want to delete slected posts?",
              cancel: "Back",
              confirm: "Delete",
              confirmAction: deletePosts,
              elementRef: lowerDeleteRef.current
            })}
          />
        </div>
      </footer>
    </section>
  </>
  )
}

export default connector(Chat);
